export const APPLICATION_INIT = 'APPLICATION_INIT';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export const SET_ROUTE_ERROR = 'SET_ROUTE_ERROR';
export const SET_TOKEN_EXPIRED_ERROR = 'SET_TOKEN_EXPIRED_ERROR';
export const SET_INVALID_REPORT_ID_ERROR = 'SET_INVALID_REPORT_ID_ERROR';
export const SET_INVALID_TOKEN_ERROR = 'SET_INVALID_TOKEN_ERROR';
export const SET_REPORT_LINK_DISABLED_ERROR = 'SET_REPORT_LINK_DISABLED_ERROR';
